import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';

import s from './StatusTierPaywall.scss';

interface Props {
  deviation: PapiDeviation;
  className?: string;
  children: React.ReactNode;
}

const StatusTierPaywall: React.FC<Props> = ({
  deviation,
  className,
  children,
}) => {
  const { t } = useTranslation();
  const { needsSubscription, isSubscribedButBlocked } =
    useSubscriptionTier(deviation);

  // TODO: this is a FE solution and only hides textContent.
  // It could be extracted (if that's something we care about)
  return needsSubscription || isSubscribedButBlocked ? (
    <div className={classnames(s['root'], className)}>
      <PromoBadge badgeType="tier" size={40} isLocked />

      <div className={s['subscription-needed-text']}>
        {needsSubscription
          ? t('deviationview.status.unsubscribedMessage')
          : t('deviationview.status.lockedMessage')}
      </div>
    </div>
  ) : (
    <>{children}</>
  );
};
StatusTierPaywall.displayName = 'StatusTierPaywall';

export default StatusTierPaywall;
